import { Children, isValidElement } from "react";
var NAVIGATOR_CONFIG = "__oneNavigatorConfig";
function isNavigatorConfigChild(child) {
  return isValidElement(child) && typeof child.type === "function" && child.type[NAVIGATOR_CONFIG] === true;
}
function getCustomNavigatorChildren(children) {
  var custom = [];
  Children.forEach(children, function(child) {
    if (child != null && !isNavigatorConfigChild(child)) {
      custom.push(child);
    }
  });
  return custom;
}
export {
  NAVIGATOR_CONFIG,
  getCustomNavigatorChildren,
  isNavigatorConfigChild
};
//# sourceMappingURL=children.js.map
